// extracted by css-extract-rspack-plugin
export default {"modelName":"ModelSwitcher-module__modelName__EJ9Hv","selectAnchor":"ModelSwitcher-module__selectAnchor__nkQWD"};